<template>
	<div class="p4">
		<!-- Cancellation Reason Text -->
		<core-form-input
			componentName="j-base-input-long-text"
			:label="$t('cancellation_reason')"
			name="cancellationReason"
			v-model="reason"
			v-validate="'required'"
			:status="errors.first('cancelPolicy') ? 'error' : null"
		/>

		<!-- Toggle for sending cancellation email to client -->
		<core-form-input
			v-if="$store.state.settings.policies.cancelling.hasSendEmail"
			:label="this.$t('send_cancellation_email')"
			componentName="j-base-radios"
			name="sendEmailToggle"
			class="mt8"
			v-model="sendEmailToggle"
			v-validate="'required'"
			:options="[
				{ name: $t('yes'), value: 'yes' },
				{ name: $t('no'), value: 'no' }
			]"
		/>

		<j-button class="mt8" @click="cancelPolicy" action="cancelPolicy">{{ this.$t("cancel_policy") }}</j-button>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton/"
import api from "../api/"
import { cancellation } from "@/clientSettings/templates/asia_uat.js"
export default {
	components: {
		CoreFormInput,
		JButton
	},
	props: {
		id: {
			type: String,
			required: true
		},
		contractHolder: {
			type: Object,
			required: true
		},
		contractInsured: {
			type: Array,
			required: true
		},
		otherContractHolders: Array,
		createdAt: {
			type: String,
			required: true
		},
		cancellationReason: String
	},
	data() {
		return {
			reason: null,
			sendEmailToggle: "no"
		}
	},
	methods: {
		initialize() {
			this.reason = this.cancellationReason
		},
		composeEmailPayload() {
			const policyNumber = this.id
			const primaryHolder = this.contractHolder.name
			const otherHoldersArray = this.otherContractHolders.map(
				item => item.name
			)
			const policyHolders = [primaryHolder, ...otherHoldersArray]
			const insured = this.contractInsured.map(item => item.name)
			const applicationDate = this.createdAt
			return {
				policyNumber,
				policyHolders,
				insured,
				applicationDate
			}
		},
		async sendCancellationEmail(emailAddress) {
			const payload = this.composeEmailPayload()
			const res = await api.sendNotification({
				input: {
					type: "cancellation",
					emailMessage: cancellation({
						toEmail: emailAddress,
						...payload
					})
				}
			})
		},
		async cancelPolicy() {
			const isValid = await this.$validator.validate()
			if (!isValid) return
			this.isCancelPolicyLoading = true
			// Cancel policy and update cancellation reason
			const res = await api.cancelPolicy({
				policyId: this.id,
				reason: this.reason
			})
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}
			// 1. Filter contacts of holder and return those with type === "email"
			// 2. Create a new array with values that pass filter
			// 3. Send cancellation email to each email in array
			const contacts = this.contractHolder.contacts
			if (contacts !== null && this.sendEmailToggle === "yes") {
				const emails = contacts
					.filter(contact => {
						if (contact.type === "email")
							return contact.value
					})
					.map(item => item.value)
				Promise.all(emails).then(result =>
					result.forEach(item =>
						this.sendCancellationEmail(item)
					)
				)
			}
			// Emit event
			this.$emit("cancelled")
			// Toast Message
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("policy_cancelled")
				}
			})
		}
	},
	mounted() {
		this.initialize()
	}
}
</script>